<template>
  <div :class="[ useSubtitle ? 'sub-title' : 'active-header', {'step-header-background': useBackgroundColor}, 'step-header']">
		<h2>{{ msg }} </h2>
		<span class="pull-right small">Steg {{currentStep}}/{{maxStep}}</span>
	</div>
</template>

<script>
export default {
	props: {
		msg: {
			type: String,
			required: true,
		},
		currentStep: {
			type: Number,
			required: true,
		},
		maxStep: {
			type: Number,
			required: true,
		},
		useSubtitle: {
			type: Boolean,
			required: true,
			default: true,
		},
		useBackgroundColor: {
			type: Boolean,
			required: true,
			default: true,
		},
	},
	data() {
		return {

		};
	},
};
</script>
